import { FaqPage } from "./Faq";
export default FaqPage;